// ============================================================================
// KOREAN TRANSLATIONS - BIBLE FACTS
// ============================================================================
// 성경에 관한 흥미로운 사실들

export const bibleFactsKo = [
  {
    category: "구조",
    text: "성경은 약 1,500년에 걸쳐 40명 이상의 저자들이 기록한 66권의 책으로 구성되어 있습니다",
    source: "성경학 연구"
  },
  {
    category: "번역",
    text: "성경은 역사상 가장 많이 번역된 책으로, 3,000개 이상의 언어로 번역되었습니다",
    source: "위클리프 성서 번역 선교회"
  },
  {
    category: "구절",
    text: "성경 전체에는 31,173개의 구절이 있으며, 구약에 23,214개, 신약에 7,959개가 있습니다",
    source: "성경 통계"
  },
  {
    category: "영향력",
    text: "시편은 성경에서 가장 긴 책이며 150편의 시로 구성되어 있고, 오바댜서는 가장 짧은 책입니다",
    source: "성경 분석"
  },
  {
    category: "역사",
    text: "사해 사본은 서기전 3세기부터 1세기까지의 성경 필사본을 포함하고 있으며, 성경 본문의 신뢰성을 확증합니다",
    source: "고고학적 발견"
  },
  {
    category: "문학",
    text: "성경은 역사, 시, 예언, 서신, 묵시록 등 다양한 문학 장르를 포함하고 있습니다",
    source: "문학 분석"
  },
  {
    category: "보편성",
    text: "성경은 역사상 가장 많이 읽힌 책으로, 매년 수백만 부가 배포되며 모든 문화에 영향을 미칩니다",
    source: "세계 통계"
  }
];

export default bibleFactsKo;
